import { useTranslate } from "@refinedev/core";
import { Eyebrow } from "@libertify/ui";
import { formatLessonNumber } from "../formatLessonNumber";

type LessonLabelProps = Readonly<{
  lessonNumber: number;
}>;

export const LessonLabel = ({ lessonNumber }: LessonLabelProps) => {
  const t = useTranslate();
  const paddedNumber = formatLessonNumber(lessonNumber);

  return (
    <Eyebrow size="s">
      {t("pages.tutorials.lessonLabel", { number: paddedNumber })}
    </Eyebrow>
  );
};
